<template>
  <div class="teamYJtable" v-loading="loadingTrue">
    <!-- 施工队和班组工队里得经营业绩 -->
    <el-table
      :data="tableData"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-if="!loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt style="margin-bottom:10px;line-height:0px;margin-top:50px;width:100px"/>
        <p class="noText" style="color:#666666;fontSize:16px;line-height:30px;margin-bottom:50px">暂无数据</p>
      </template>
      <el-table-column  label="业绩类型" prop="typeName" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.typeName||'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="项目名称" prop="name" show-overflow-tooltip width="230">
         <template slot-scope="scope">
          <span>{{ scope.row.name||'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="业主单位" prop="owner" show-overflow-tooltip width="300">
         <template slot-scope="scope">
          <span>{{ scope.row.owner||'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="项目金额" prop="price" width="170"> 
         <template slot-scope="scope">
          <span>{{ scope.row.price||'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="项目状态" prop="status" show-overflow-tooltip width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.status==0 ? '未开始' :  scope.row.status==1 ? '进行中' : scope.row.status==2 ? '已完结' : '' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  label="主营业务">
        <template slot-scope="scope">
          <el-tooltip trigger="hover"  placement="top-start" :disabled="!scope.row.businessDescription">
            <div  slot="content" style="line-height:20px">
              <p>业务描述</p>
              <p>
              {{scope.row.businessDescription}}
              </p>
            </div>
            <div class="text_ellipsis">
              {{ scope.row.mainBusiness || '/' }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <el-table-column  label="甲方证明人" prop="certifier" show-overflow-tooltip>
         <template slot-scope="scope">
          <span>{{ scope.row.certifier||'/' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :param="param" @change="getTeamResultsList" v-if="tableData&&tableData.length" :loadingTrue="loadingTrue"></Pagination>
    <PerformanceDetailsModal ref="performanceDetailsModal"/>
  </div>
</template>

<script>
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
import { apiTeamDetail } from '@/api/apiTeamDetail'
import moment from "moment"
export default {
  data () {
    return {
      setColumnDataColor,
      setCellStyle,
      loadingTrue: false,
      tableData: [],
      param: {
        page: 1,
        limit: 20,
        teamNo: '',
        total: 0
      }
    }
  },
  props: {
    isGzbj: {
      type: Boolean,
      default:false
    },
    data:{
      type:Object
    }
  },
  components: {
    Pagination: () => import('@/views/Construction/components/Pagination'), // 分页
    PerformanceDetailsModal : ()=>import('./teamYJtable/PerformanceDetailsModal'), // 工程业绩详情弹窗
  },
  created () {
    this.getTeamResultsList()
  },
  methods: {
    formatDate(date){
      return moment(date).format('YYYY/MM/DD')
    },
    async getTeamResultsList () {
      this.loadingTrue = true
      if (this.$route.query.teamNo){
        this.param.teamNo = this.$route.query.teamNo
      } 
      let res = await apiTeamDetail.getTeamResultsList(this.param)
      if (res.data.code === 200) {
        this.tableData = res.data.data.records
        this.param.total = res.data.data.total
        this.loadingTrue = false
      } else {
        this.loadingTrue = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-table__empty-text{
  line-height: 0px;

}
 .text_ellipsis {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
 }
 /deep/.cell{
   padding: 0 20px !important;
 }
 /deep/td{
   height: 44px !important;
 }
 /deep/th{
   height: 44px !important;
   padding: 10px 0 !important;
 }
</style>
